module.exports = __webpack_public_path__ + "img/03.46fe0edd.png";